import React, { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import { Card, CardContent, Grid, Typography } from "@material-ui/core";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import E_MeterReadsData from "./e_view/_e_meter_reads_card";
import { adminService } from "../../../services/admin.service";
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import { store } from "../../../helpers/store";
import { readsService } from "../e_meter_reads/e_service/e_service";
import { commonService } from "../../../services/common.service";
import { Skeleton } from "@material-ui/lab";
import CircularProgress from '@material-ui/core/CircularProgress';
import ExpandMoreSharpIcon from "@material-ui/icons/ExpandMoreSharp";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
export const STYLED_MENU_ITEM = withStyles((theme) => ({
        root: {
          justifyContent: "flex-start !important",
          color:  theme.palette.eRich?.base+" !important",
          whiteSpace:"initial !important",
          fontSize: "0.8rem",
        },
      }))(MenuItem);
    
      export const STYLED_SELECT = withStyles((theme) => ({
        root: {
          color: theme.palette.eDark?.base,
          fontSize: "0.8rem",
          border: "1px solid ",
          borderRadius: "4px",
          padding: "7px 10px",
          justifyContent: "flex-start",
          borderColor: theme.palette.eLight?.base,
        },
        select: {
          "&:focus": {
            borderRadius: "0.25rem",
          }
        },
        icon: {
          color: theme.palette.eDark?.base,
        },
      }))(Select);


 export const STYLED_CHECKBOX=withStyles((theme)=>({
   root:{
     color:theme.palette.eSecondary?.base,
    "&$checked": {
      color: theme.palette.eSecondary?.base +"!important"
   },
   
  },
  checked: {},
 }))(Checkbox)

 const LightTooltip = withStyles((theme) => ({
    tooltip: {
    fontSize:"0.6rem",
      backgroundColor: theme.palette.eWhite?.base,
      color: theme.palette.ePrimary?.base,
      boxShadow: theme.shadows[2],
      border: "1px solid " + theme.palette.eLight?.base,
    },
  }))(Tooltip);
const useStyles = makeStyles((theme) => ({
    dropdownMenuItem: {
        "& .MuiListItemText-primary": {
            fontSize: "0.8rem"
        }
    },
    title:{
        marginBottom: "5px",
        color:theme.palette.ePrimary?.base
    },
    dropdown:{
        marginRight: "12px",
    },
    button:{
        marginTop: "22px",
    },
    buttonInside:{
      "&:hover": {
        backgroundColor:theme.palette.eSecondary?.hover,
      },
      backgroundColor:theme.palette.eSecondary?.base,
        color:theme.palette.eWhite?.base,
        borderRadius:"16px",
        fontSize:"14px"
    },
    alertText: {
        display: "flex", height: "100%", alignItems: "center", border: "1px", justifyContent: "center"
      },
    img:{
        marginTop: "8px" 
    },
    check:{
      color:theme.palette.eSecondary?.base,
      "&$checked": {
        color: theme.palette.eSecondary?.base +"!important"
      }
    },
    font:{
        paddingBottom:"2px"
    },des:{
        paddingBottom:"2px",
        color:theme.palette.ePrimary?.base+"!important"
    }
}));

export default function MeterReads() {
 
const MenuProps = {
  disableScrollLock: false,
  anchorOrigin: {
    vertical: "bottom",
  },
  transformOrigin: {
    vertical: "top",
  },
  getContentAnchorEl: null
};

    const classes = useStyles()
    const [value, setValue] = useState([]);
    const [disable, setDisable] = useState(true)
    const [tooltip, setTooltip] = useState(false)
    const [tooltipContent, setTooltipContent] = useState()
    const [open, setOpen] = useState(false)
    const [data, setData] = useState(null)
    const [registers, setRegisters] = useState([])
    const [description, setDescription] = useState()
    const [MeterImage, setMeterImage] = useState("");
    const [Dropdowndefault, setDefault] = useState();
    const [regLoading, setRegLoading] = useState(false);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [noRecordsDescription, setNoRecordsDescription] = useState("")
    let meterLogo = useSelector(
        (store) => store?.parametersWidgets?.ParameterLookup?.E_METER_READS_IMAGE
    );
    const {t:labels, ready: labelReady} = useTranslation("label-E_METER_READS")
    const {t:LabelsHighUsage, ready: usageTrendLabelReady} = useTranslation("label-E_USAGE_TREND") 
    const languageCode = useSelector(
        (state) => state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
    );
    let primaryIdentifier = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.PRIMARY_IDENTIFIER);
    let accountId = store?.getState()?.meterDetails?.accountId;
    const saId = useSelector((state) => state?.meterDetails?.getSaInfo?.saId);
    useEffect(() => {
        if (meterLogo) {
            commonService.getAssestUrl(meterLogo).then((response) => {
                setMeterImage(response);
            })
            .catch((err) => {
                setMeterImage("");
            })
        }
    }, [meterLogo]);

    const getMeterReads = () => {
        if (accountId && saId) {
            setRegLoading(false)
            setOpen(true)
            setData(false);
            readsService.meterReads(accountId, saId)
                .then((response) => {
                    setRegLoading(false)
                    if (response?.data?.getRealTimeMeterReads?.billSegments?.billSegmentList?.billSegment) {
                        setOpen(false)
                        setStartDate(response?.data?.getRealTimeMeterReads?.billSegments?.billSegmentList?.startDate)
                        setEndDate(response?.data?.getRealTimeMeterReads?.billSegments?.billSegmentList?.endDate)
                        setRegisters(response?.data?.getRealTimeMeterReads?.billSegments?.billSegmentList?.measurements?.consumptionList)
                    } else {
                        setOpen(false)
                        setRegLoading(false)
                        setRegisters([])
                    }
                })
                .catch((err) => {
                    setOpen(false)
                    setRegLoading(false)
                    setRegisters([])
                })
        }
    }


    useEffect(() => {
        setData(null)
        setOpen(false)
        setValue([])
        getMeterReads()
    }, [accountId, saId])
    const {t:content, ready: contentReady}=useTranslation("content-E_METER_READS");
    const handler = (e) => {
        setValue(e.target.value)
    }
    useEffect(() => {
        if (value.length === 0) {
            setDisable(true)
        } else {
            setDisable(false)
        }
    }, [value])

    useEffect(()=>{
        if(disable){
          localStorage.removeItem("enabled_state")
        }else{
          localStorage.setItem("enabled_state",1)
        }
    
      },[disable])
    
      const handleBeforeUnload=(e)=>{
        e.preventDefault()
        e.returnValue = '';
      }
      
    //   useEffect(()=>{
    //     if(!disable){
    //      window.addEventListener("beforeunload", handleBeforeUnload,{capture:true});  
    //     }
    //     else{
    //         window.removeEventListener("beforeunload", handleBeforeUnload,{capture:true});
    //     }
    //     return () => window.removeEventListener("beforeunload", handleBeforeUnload,{capture:true})
    //   },[disable])


    const handlerclick = () => {
        setData(registers?.filter(item => value?.includes(item?.uom)))
        setDisable(true)
        setOpen(true)
    }
    useEffect(() => {
        !disable ? setTooltip(true) : setTooltip(false)
    }, [disable])
    
    useEffect(() => {
        if(languageCode){
        store.getState().snackbar = true;
        readsService.getDropdownpData("E_METER_READS",languageCode).then((resp) => {
            store.getState().snackbar = false;
            setDefault(resp?.data?.getDropdownData?.[0])         
        })
        .catch((err) => {
            store.getState().snackbar = false;
        })        
    }}, [languageCode]);
    
    useEffect(()=>{
        if(registers?.length==1){
            setValue(['KWH'])
            
        }
    },[registers])

    useEffect(()=>{ 
        if(registers?.length==1){
            setData(registers?.filter(item => value?.includes(item?.uom)))
            setDisable(true)
            setOpen(true)
        }
    },[value])


    return (
            <CardContent >
            {
                labelReady ?
                <Typography variant="h6" className={classes.title}><b>{labels("E_METER_READS_TITLE")}</b></Typography>
                : <Skeleton />
            }
                {registers.length>1 && <Grid container direction="row">
                   {registers?.length>1 && <Grid item className={classes.dropdown}>
                        <FormControl >
                            <STYLED_SELECT
                                id="demo-customized-select-native"
                                value={value}
                                onChange={handler}
                                multiple
                                disableUnderline={true}
                                IconComponent={ExpandMoreSharpIcon} 
                                renderValue={(selected) => {
                                    if (selected?.length === 0) {
                                        return Dropdowndefault?.dropDownValue;
                                    }
                                    return selected?.map(item => labelReady ? labels("E_METER_READS_UOM_" + item + "_LABEL"): "").join(', ');
                                }}
                                disabled={registers.length > 0 ? false : true}
                                displayEmpty
                                MenuProps={ MenuProps}                    
                                
                            >
                                {registers?.map((item) => (
                                    <STYLED_MENU_ITEM name={item?.uom} key={item?.uom} value={item?.uom} >
                                        <STYLED_CHECKBOX className={classes.check} checked={value.indexOf(item?.uom) > -1} />
                                        {
                                            labelReady ?
                                        <ListItemText className={classes.dropdownMenuItem} primary={labels("E_METER_READS_UOM_" + item?.uom + "_LABEL")} />
                                        : ""
                                        }
                                    </STYLED_MENU_ITEM>
                                ))}
                            </STYLED_SELECT>
                        </FormControl>
                    </Grid>}
                    <Grid item>
                        <LightTooltip disableHoverListener={tooltip} title={contentReady ? content("E_METER_READS_TOOLTIP").answer : ""}>
                            <span>
                            <Button variant="contained" className={classes.buttonInside} disabled={disable} onClick={handlerclick}>{labels("E_METER_READS_BUTTON")}</Button>
                            </span>
                        </LightTooltip>
                    </Grid>
                </Grid>}
                <Grid className={classes.img}>
                    {!open ? <Grid align="center" marginTop="4px">
                        {/* {meterLogo && (MeterImage && (
                            <img
                                height="150px"
                                src={MeterImage?.assetPath}
                            />
                        ))} */}
                        <br/>
                        {!regLoading && contentReady ? (
                            registers.length > 0 ? <Typography variant="subtitle2" className={classes.des}>{content("E_METER_READS_DES").answer}</Typography>
                            : (usageTrendLabelReady ?
                            <Typography align="center" variant="subtitle2" className={classes.des}>{LabelsHighUsage("E_ERROR")}</Typography>
                            : <Skeleton />)
                        ) : null}
                    </Grid> : null}
                </Grid>
                <Grid>
                    {open ? (data ? <E_MeterReadsData data={data} startDate={startDate} endDate={endDate}/> : <div className={classes.alertText}><CircularProgress  color="primary" /></div> ) : null}
                </Grid>
            </CardContent>
    )

}